import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import {
  APPLICABLE_DURING_TYPE,
  APPLICABLE_DURING_OPTIONS,
} from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IApplicableDuringProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const ApplicableDuring = memo<IApplicableDuringProps>(({ onChange, value }) => {
  const { proximalHourCriteria } = value

  const applicableDuring = proximalHourCriteria ? 'numDaysOut' : 'indefinitely'

  const applicableDuringHandler = (e: ISelectOption) => {
    switch (e.value) {
      case APPLICABLE_DURING_TYPE.INDEFINITELY: {
        onChange({ proximalHourCriteria: undefined })
        break
      }
      case APPLICABLE_DURING_TYPE.NUM_DAYS_OUT: {
        onChange({ proximalHourCriteria: { rangeStart: '', rangeEnd: '' } })
        break
      }
      default:
    }
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <Select
        label='Applicable During'
        placeholder='Choose an option'
        options={APPLICABLE_DURING_OPTIONS}
        value={applicableDuring}
        onChange={applicableDuringHandler}
        dataTest='modal-applicable-during-option'
        required
        large
      />
    </div>
  )
})
